import { createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from "../../utilities/api";

export const patchPromoter = createAsyncThunk("referrals/patchProfile", async (values, { rejectWithValue }) => makeRequest(`/referrals/promoter/${values.id}`, "PUT", values, rejectWithValue));

export const getReferrals = createAsyncThunk("referrals/get", async (values, { rejectWithValue }) => makeRequest("/referrals", "GET", values, rejectWithValue));
